export const ROUTES = {
  marketing: {
    home: '/',
    features: '/features',
    platform: '/platform',
    useCases: '/use-cases',
    pricing: '/pricing',
  },
  auth: { login: '/login' },
  app: {
    root: '/app',
    topicsList: '/app/topics',
    topicFeed: (id: string | number) => `/app/topics/${id}/feed`,
    topicAnalytics: (id: string | number) => `/app/topics/${id}/analytics`,
    topicNetwork: (id: string | number) => `/app/topics/${id}/network`,
    topicReports: (id: string | number) => `/app/topics/${id}/reports`,
    topicSaved: (id: string | number) => `/app/topics/${id}/saved`,
    topicTrends: (id: string | number) => `/app/topics/${id}/trends`,
    sources: '/app/sources',
    pages: '/app/pages',
    groups: '/app/groups',
    management: '/app/management',
    settings: '/app/settings',
    compare: '/app/compare',
    trends: '/app/trends',
  },
  publicView: {
    topicFeed: (slug: string) => `/public/topics/${slug}/feed`,
    topicTrends: (slug: string) => `/public/topics/${slug}/trends`,
    topicNetwork: (slug: string) => `/public/topics/${slug}/network`,
    compare: '/public/topics/compare',
  },
} as const

export const ROUTE_PATTERNS = {
  topicFeed: '/app/topics/:topicId/feed',
  topicAnalytics: '/app/topics/:topicId/analytics',
  topicNetwork: '/app/topics/:topicId/network',
  topicReports: '/app/topics/:topicId/reports',
  topicSaved: '/app/topics/:topicId/saved',
  topicTrends: '/app/topics/:topicId/trends',
} as const
